import { createContext } from 'react'
import { TenantProps } from '../../bootstrap/tenant'

const initProps: TenantProps = {
  windowWidth: 0,
  customContent: null
}

const InitialPropsContext = createContext(initProps)

export default InitialPropsContext
